import { useContext, Context } from 'react';

type NonUndefined<T> = T extends undefined ? never : T;

export function useSafeContext<T>(contextObject: Context<T>): NonUndefined<T> {
	const context = useContext(contextObject);

	if (!contextObject.displayName) {
		throw new Error('Context.displayName is not set, it must be set for useSafeContext');
	}

	if (context === undefined) {
		// Get the displayName without "Context", so just "Count" here
		const contextName = contextObject.displayName.split('Context')[0];
		throw new TypeError(`use${contextName} must be used within a ${contextName}Provider`);
	}

	return context as NonUndefined<T>;
}
